import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoaderService {

    /**
     * Loading behavior subject
     * @private
     */
    private _loading = new BehaviorSubject<boolean>(false);

    constructor() {
    }

    /**
     * Show loading screen
     */
    public show(): void {
        this._loading.next(true);
    }

    /**
     * Hide loading screen
     */
    public hide(): void {
        this._loading.next(false);
    }

    /**
     * Public get loader
     */
    public get loader$(): Observable<boolean> {
        return this._loading.asObservable();
    }
}
